/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { palette } from './preMerge/themePalette';
import { breakpoints } from './preMerge/themeBreakpoints';
import { typography } from './preMerge/themeTypography';
import { extraValues } from './preMerge/themeExtraValues';
import { overrides } from './postMerge/themeOverrides';
import { props } from './postMerge/themeProps';
import { customTheme } from './postMerge/themeCustomTheme';

// preMergeTheme is an object containing ONLY static values. It is possible
// but not always recommended (a11y, standards) to override it using custom NPO theme
// This is a good place to put any schema color, typography, etc.
export const preMergeTheme = {
  palette,
  breakpoints,
  typography,
  ...extraValues,
};

// postMergeTheme returns an object containing derived or theme-dependant values. The custom NPO theme
// can't override any of them.
// This is a good place to override MUI default values/props.
export const postMergeTheme = theme => ({
  overrides: overrides(theme),
  props: props(theme),
  customTheme: customTheme(theme),
});
